import {useCallback, useState} from 'react';
import {getSearchSuggestCompanies} from 'api/search';
import {keys} from 'lodash';
import {getCountryNameById} from 'utils/locales';
import {debounce} from 'lodash';
import Cookies from 'utils/cookies';
import {alertByError} from 'utils/alerts';

function useGetSearchInputSuggestion(verifyCaptcha) {
  const [searchType, setSearchType] = useState('company');
  const [isLoading, setIsLoading] = useState(false);
  const [isDebouncing, setIsDebouncing] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [recordsCount, setRecordsCount] = useState(0);

  const getSuggestion = async (value) => {
    try {
      setIsLoading(true);
      setIsDebouncing(false); // No longer debouncing, now actually loading
      const {data, meta} = await getSearchSuggestCompanies({q: value});

      const result = keys(data).map((key) => {
        const item = data[key];
        const countriesId = item[0];
        const companyName = item[1];
        const certificationNumber = item[2];

        return {
          company_id: key,
          company_name: companyName,
          countries_id: countriesId,
          country_name: getCountryNameById(countriesId),
          certification_number: certificationNumber,
        };
      });

      const searchType = !!result.find((item) => item.certification_number);
      setSearchType(searchType ? 'cert' : 'ce');

      setSuggestions(result);
      setRecordsCount(meta.total_rows);

      setIsLoading(false);
      return true;
    } catch (e) {
      document.activeElement.blur();
      if (e.status === 429) {
        Cookies.captchaToken = '';
        await alertByError(e);
      } else {
        if (e.code === 'invalid_captcha_token') {
          verifyCaptcha();
        }
      }

      setIsLoading(false);
      setIsDebouncing(false);
      return false;
    }
  };

  function clearSuggestions() {
    setSuggestions([]);
    setIsDebouncing(false);
    setRecordsCount(0);
  }

  const debouncedGetSuggestion = useCallback(debounce(getSuggestion, 500), []);

  const triggerDebouncedSearch = (value) => {
    setIsDebouncing(true);
    debouncedGetSuggestion(value);
  };

  return {
    searchType,
    suggestions,
    getSuggestion,
    debouncedGetSuggestion,
    triggerDebouncedSearch,
    clearSuggestions,
    isLoading,
    isDebouncing,
    recordsCount,
  };
}

export default useGetSearchInputSuggestion;
